const getLoopIsDisabled = (showSimulationMode, userDetails) =>
  showSimulationMode === false && !!userDetails?.simulation_mode;

export default getLoopIsDisabled;
